import Container from "../common/Container";
import Button from "../common/Button";
import { site } from "../../data/siteData";
import { FaPhone, FaArrowRight } from "react-icons/fa6";
import "../../styles/CTA.css";

export default function CTA() {
  const handleCall = () => {
    window.location.href = `tel:${site.phone.replace(/\s+/g, "")}`;
  };

  return (
    <section className="cta-wrapper">
      <Container>
        <div className="cta-glass-card">
          {/* Background Decorative Elements */}
          <div className="cta-grid-pattern"></div>
          <div className="cta-floating-shape shape-1"></div>
          <div className="cta-floating-shape shape-2"></div>
          
          <div className="cta-content">
            <div className="cta-text-side">
              <span className="cta-badge">Premium Cleaning Excellence</span>
              <h2 className="cta-title">Ready for a spotless space?</h2>
              <p className="cta-subtitle">
                Join hundreds of satisfied clients in {site.locationLine || "your area"}. 
                Call us today for a non-obligation estimate.
              </p>
              <div className="cta-phone-display" onClick={handleCall}>
                <div className="phone-icon-circle">
                  <FaPhone />
                </div>
                <div>
                  <span className="phone-label">Direct Line</span>
                  <div className="phone-number">{site.phone}</div>
                </div>
              </div>
            </div>

            <div className="cta-button-side">
              <Button
                variant="primary"
                className="cta-main-btn"
                onClick={handleCall}
              >
                Call Now <FaArrowRight className="btn-arrow" />
              </Button>
              <p className="cta-availability">Available: Mon - Fri, 8am - 10pm</p>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}